"use strict";

exports.__esModule = true;
exports.CallRequestButtons = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _context3 = require("@prisma-cms/context");

var _context4 = _interopRequireDefault(_context3);

var _CallRequestButton = require("../CallRequestButton");

var _CallRequestButton2 = _interopRequireDefault(_CallRequestButton);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CallRequestButtons = exports.CallRequestButtons = (_temp = _class = function (_Component) {
  _inherits(CallRequestButtons, _Component);

  function CallRequestButtons() {
    _classCallCheck(this, CallRequestButtons);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CallRequestButtons.prototype.render = function render() {
    var _this2 = this;

    var _context = this.context,
        callRequests = _context.callRequests,
        currentUser = _context.user,
        acceptCall = _context.acceptCall,
        rejectCall = _context.rejectCall;

    var _ref = currentUser || {},
        currentUserId = _ref.id;

    if (!currentUserId) {
      return null;
    } // const requestedCalls = callRequests && callRequests.filter(n => ["Created"].indexOf(n.status) !== -1) || [];


    var requestedCalls = callRequests; // return "sdfdsf";

    var callsView = [];
    requestedCalls.map(function (requestedCall) {
      var callRequestId = requestedCall.id,
          calledId = requestedCall.Called.id,
          room = requestedCall.Room.id;
      /**
       * Если это новый звонок и адресован текущему пользователю, выводим запрос
       */
      // if (calledId === currentUserId) {
      //   callsView.push(<CallRequestButton
      //     key={callRequestId}
      //     // item={currentCallRequest}
      //     item={requestedCall}
      //     accept={event => {
      //       acceptCall(callRequestId);
      //       // setActiveCall(room);
      //       // setActiveCall(currentCallRequest);
      //     }}
      //     reject={event => {
      //       rejectCall(callRequestId);
      //     }}
      //   />)
      // }

      callsView.push(_react2.default.createElement(_CallRequestButton2.default, {
        key: callRequestId // item={currentCallRequest}
        ,
        item: requestedCall,
        accept: function () {
          var _ref2 = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator2.default.mark(function _callee(event) {
            return _regenerator2.default.wrap(function _callee$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    acceptCall(callRequestId).then(function (r) {});
                  // setActiveCall(room);
                  // setActiveCall(currentCallRequest);

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        reject: function reject(event) {
          rejectCall(callRequestId);
        }
      }));
    });
    return callsView;
  };

  return CallRequestButtons;
}(_react.Component), _class.contextType = _context4.default, _temp);
exports.default = CallRequestButtons;